import { useEffect, useState } from 'react'

/**
 * Contador de visitantes "en vivo" que fluctúa de forma natural.
 */
export function useLiveViewers(base = 27, spread = 6) {
  const [viewers, setViewers] = useState(base)

  useEffect(() => {
    const tick = () => {
      // No gastamos ciclos si la pestaña no está visible.
      if (typeof document !== 'undefined' && document.hidden) return
      setViewers((current) => {
        const delta = Math.round((Math.random() - 0.45) * 3)
        const next = current + delta
        const min = base - spread
        const max = base + spread
        if (next < min) return min
        if (next > max) return max
        return next
      })
    }

    const id = window.setInterval(tick, 4500)
    return () => window.clearInterval(id)
  }, [base, spread])

  return viewers
}
